import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustBadges = () => {
  const badges = [
    { icon: 'Shield', title: 'Conformité RGPD', description: 'Vos données sont protégées', color: '#22d3ee' },
    { icon: 'Award', title: 'Certifications', description: 'Techniciens qualifiés et assurés', color: '#22c55e' },
    { icon: 'Clock', title: 'Disponibilité 24/7', description: 'Service d\'urgence garanti', color: '#eab308' },
    { icon: 'ShieldCheck', title: 'Assurance', description: 'Garantie décennale incluse', color: '#8b5cf6' }
  ];

  return (
    <section className="marketing-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {badges?.map((badge, index) => (
            <div 
              key={index}
              className="marketing-card text-center p-6"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-full flex items-center justify-center" style={{ background: `${badge.color}20` }}>
                <Icon name={badge?.icon} size={24} style={{ color: badge.color }} />
              </div>
              <h3 className="font-semibold text-white mb-1">{badge?.title}</h3>
              <p className="marketing-muted text-sm">{badge?.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;